
//MUI :



function Intro() {


    return (

        <section className="intro" id="intro">
            <div className="intro-top">
                <h1><span className="intro-top-txt1">Bonjour! Je suis</span>Manuel VIVION<br /><span className="intro-top-txt2">Développeur web fullstack</span></h1>
                <span className="intro-top-underline"></span>
            </div>
            <div className="intro-middle">
                <img src={require("../../images/portrait_MV_2.jpg")} title="Photo portrait de Manuel VIVION" alt="portrait de Manuel VIVION, beau gosse!" />

            </div>
            <div className="intro-bottom">
                <img src={require("../../images/logos/next-js-icon.png")} alt="Next Logo" title="Next" />
                <img src={require("../../images/logos/reactjs-icon.png")} alt="React Logo" title="React" />
                <img src={require("../../images/logos/ts-logo-128.png")} alt="Typescript Logo" title="Typescript" />
                <img src={require("../../images/logos/js.png")} alt="javascript Logo" title="Javascript" />
                {/* <img src={require("../../images/logos/w3_html5-icon.png")} alt="logo html5" title="html5" /> */}
                <img src={require("../../images/logos/tailwind-icon.png")} alt="logo tailwindcss" title="tailwindcss" />
                <img src={require("../../images/logos/jsIconGreen.png")} alt="NodeJs Logo" title="Node.Js" />
                <img src={require("../../images/logos/prisma-icon.png")} alt="prisma Logo" title="Prisma" />
                <img src={require("../../images/logos/postgre-icon.png")} alt="postGreSql Logo" title="PostGreSql" />
                <img src={require("../../images/logos/mysql-official.png")} alt="MySql Logo" title="MySql" />
            </div>
        </section>
    );
}

export default Intro;